import {ApiEnumItem} from '../../../types/ApiEnum';
import {getAllTreeKeys} from './getAllTreeKeys';

/**
 * To make decision, if is this node the last selected in Tree structure
 * Required for filters to use only last nodes
 * @param node
 * @param selected
 */
export const isLastSelectedNode = (node: ApiEnumItem, selected: string[]) => {
  const allChildren = getAllTreeKeys(node);
  allChildren.pop(); //whithout key of current node
  return !node?.children?.length || !allChildren?.some((x) => selected?.includes(x));
};
